import { FC } from 'react';

type Props = {
    className?: string;
};

const Hotel_01_Icon: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="#2B2B2B"
            className={className}
        >
            <path
                d="M2.80078 3.6001V16.3998C2.80078 17.1541 2.80078 17.5312 3.03509 17.7655C3.2694 17.9998 3.64652 17.9998 4.40075 17.9998H15.6005C16.3548 17.9998 16.7319 17.9998 16.9662 17.7655C17.2005 17.5312 17.2005 17.1541 17.2005 16.3998V3.6001"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.80078 6.7998V7.99978M8.80078 7.99978V9.19976M8.80078 7.99978H11.2007M11.2007 6.7998V7.99978M11.2007 7.99978V9.19976"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6023 17.9997V14.7997C11.6023 13.9161 10.886 13.1997 10.0023 13.1997C9.11865 13.1997 8.40234 13.9161 8.40234 14.7997V17.9997"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.00391 3.59997H6.80381C7.31572 2.6618 8.55554 2 10.0037 2C11.452 2 12.6918 2.6618 13.2037 3.59997H18.0036"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.20312 6.7998H6.00311M5.20312 9.99974H6.00311M5.20312 13.1997H6.00311"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.0039 6.7998H14.8039M14.0039 9.99974H14.8039M14.0039 13.1997H14.8039"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Hotel_01_Icon;
